import moment from 'moment';
import { type AxiosPromise } from 'axios';
import { http, axiosClient } from './config';
import { type IUser } from '../interfaces/User.interface';

export const UserService = (url: string | ''): AxiosPromise<IUser> => {
	return http.get(url);
};

const axiosApi = axiosClient(`${import.meta.env.REACT_APP_API_ACHS}`);

export const userWorker = (
	token: string,
	entidad: string,
	filtroNombreNumeroDocumento: string,
	roles: string,
	pagina: number,
	condicion: string,
	limite: number,
): AxiosPromise<IUser> => {
	const funcionalidades = roles.split(',');
	const rolesQueryString =
		funcionalidades && funcionalidades.length > 0
			? funcionalidades
					.map((n, index) => `roles[${index}]=${n}`)
					.join('&')
			: '';

	return axiosApi.get(
		`/admin/v1/gestion-usuarios/usuarios/empresa?${rolesQueryString}&entidad=${entidad}&filtroNombreNumeroDocumento=${filtroNombreNumeroDocumento}&condicion=${condicion}&limite=${limite}&pagina=${pagina}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'ms-company-id': entidad,
			},
		},
	);
};

export const userWorkerDownload = (
	token: string,
	entidad: string,
	filtroNombreNumeroDocumento: string,
	roles: string[],
	condicion: string,
): AxiosPromise<IUser> => {
	const rolesQueryString =
		roles && roles.length > 0
			? roles.map((n, index) => `roles[${index}]=${n}`).join('&')
			: '';

	return axiosApi.get(
		`/admin/v1/gestion-usuarios/usuarios/empresa/export?${rolesQueryString}&entidad=${entidad}&filtroNombreNumeroDocumento=${filtroNombreNumeroDocumento}&condicion=${condicion}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'ms-company-id': entidad,
			},
		},
	);
};

export const editUserRoles = (
	token: string,
	entidad: string,
	numeroDocumento: string,
	condicion: string,
	roles: any[],
): AxiosPromise<IUser> => {
	const currentdate = new Date();
	currentdate.setDate(currentdate.getDate() + 30);
	const newRoles = roles.map((role: any) => {
		return {
			fechaFinalizacion: moment(currentdate).format('YYYY-MM-DD'),
			codigoRol: role,
		};
	});

	return axiosApi.put(
		'/admin/v1/gestion-usuarios/usuarios/modificar/roles',
		{
			entidad,
			numeroDocumento: numeroDocumento.split('-')[0],
			condicion: condicion.toUpperCase(),
			roles: newRoles,
		},
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'ms-company-id': entidad,
			},
		},
	);
};

export const deleteUserRoles = (
	token: string,
	entidad: string,
	numeroDocumento: string,
): AxiosPromise<IUser> => {
	return axiosApi.delete(
		`/admin/v1/gestion-usuarios/usuarios/${
			numeroDocumento.split('-')[0]
		}/eliminar/roles/empresa/${entidad}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'ms-company-id': entidad,
			},
		},
	);
};
